import React, { useEffect } from 'react';
import { GameShow, MediaSource } from '../index';
import { debugLog } from '../../../../utils/debug';

// Force HTTPS for media server since it's running with SSL
// This was PREVIOUSLY with a standalone server running on 10.0.0.102:8443
// const REMOTE_SERVER = 'https://10.0.0.102:8443';

// Use domain-relative paths for media server
const MEDIA_BASE_PATH = '/mediagen/gameshow/out';

// add salt to the path to avoid caching, to avoid caching and guessing the path
const EPISODE_PATH = 'e1_797695';

// Define the sequence of videos to be played
const mediaSources: MediaSource[] = [
  // 1. Introduction video
  {
    videoUrl: `${MEDIA_BASE_PATH}/${EPISODE_PATH}/scene_0/final.mp4`,
    plainCaptionsSrc: `${MEDIA_BASE_PATH}/${EPISODE_PATH}/scene_0/captions.vtt`,
    interactiveCaptionsSrc: `${MEDIA_BASE_PATH}/${EPISODE_PATH}/scene_0/interactive_captions.vtt`,
  },

  // 2. First question/challenge
  {
    videoUrl: `${MEDIA_BASE_PATH}/${EPISODE_PATH}/scene_1/final.mp4`,
    plainCaptionsSrc: `${MEDIA_BASE_PATH}/${EPISODE_PATH}/scene_1/captions.vtt`,
    interactiveCaptionsSrc: `${MEDIA_BASE_PATH}/${EPISODE_PATH}/scene_1/interactive_captions.vtt`,
  },
    // 3. First question/challenge
  {
    videoUrl: `${MEDIA_BASE_PATH}/${EPISODE_PATH}/scene_2/final.mp4`,
    plainCaptionsSrc: `${MEDIA_BASE_PATH}/${EPISODE_PATH}/scene_2/captions.vtt`,
    interactiveCaptionsSrc: `${MEDIA_BASE_PATH}/${EPISODE_PATH}/scene_2/interactive_captions.vtt`,
  },
];

export const GameShowPage: React.FC = () => {
  useEffect(() => {
    // Load Font Awesome for icons
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css';
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, []);

  // Log the URLs being used
  useEffect(() => {
    debugLog('Media Sources: ' + JSON.stringify(mediaSources, null, 2));
  }, []);

  return (
    <div className="game-show-page">
      <GameShow mediaSources={mediaSources} />
    </div>
  );
};

export default GameShowPage;